export default "const purchase = (_purchase_price : tez) : bool => {\n  // Type your solution below\n\n  return true;\n};\n";